<template>
	<v-switch v-model="isChecked" :value="facet.id" :label="facet.label" />
</template>

<script lang="ts" setup>
import type {CheckboxFacet, TextFacet} from "@apptus/esales-api";
import {useVModel} from "@vueuse/core";

const properties = defineProps<{
	facet: CheckboxFacet | TextFacet;
	modelValue?: (string | number | boolean)[];
}>();

const emit = defineEmits<{
	(event: "update:modelValue", value?: (string | number | boolean)[]): void;
}>();

const selectedItems = useVModel(properties, "modelValue", emit);

const isChecked = computed<boolean>({
	get() {
		return !!selectedItems.value && selectedItems.value?.length > 0;
	},
	set(value) {
		selectedItems.value = value ? ["true"] : [];
	},
});
</script>
